export enum Campaign {
	Index = 'campaign.index',
	Show = 'campaign.show',
	Update = 'campaign.update',
	Delete = 'campaign.delete',
	UpdateStatus = 'campaign.update_status',
	Settlement = 'campaign.settlement',

	PriceIndex = 'campaign_view_price.index',
	PriceShow = 'campaign_view_price.show',
	PriceCreate = 'campaign_view_price.create',
	PriceUpdate = 'campaign_view_price.update',
	PriceDelete = 'campaign_view_price.delete',

	PanelIndex = 'campaign_panel.index',
	PanelShow = 'campaign_panel.show',
	PanelCreate = 'campaign_panel.create',
	PanelUpdate = 'campaign_panel.update',
	PanelDelete = 'campaign_panel.delete',

	ContentTemplateIndex = 'campaign_content_template.index',
	ContentTemplateShow = 'campaign_content_template.show',
	ContentTemplateCreate = 'campaign_content_template.create',
	ContentTemplateUpdate = 'campaign_content_template.update',
	ContentTemplateDelete = 'campaign_content_template.delete',

	ReleaseTimeIndex = 'campaign_release_time.index',
	ReleaseTimeShow = 'campaign_release_time.show',
	ReleaseTimeCreate = 'campaign_release_time.create',
	ReleaseTimeUpdate = 'campaign_release_time.update',
	ReleaseTimeDelete = 'campaign_release_time.delete',
}
